<template>
    <div>

        <nav class="flex" aria-label="Breadcrumb">
            <ol class="flex items-center space-x-4">
                <li>
                    <div>
                        <a href="/admin/pages/desks" class="text-gray-400 hover:text-gray-500">
                            <!-- Heroicon name: solid/home -->
                            <svg class="flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                 fill="currentColor" aria-hidden="true">
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
                            </svg>
                            <span class="sr-only">Home</span>
                        </a>
                    </div>
                </li>

                <li>
                    <div class="flex items-center">
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-300" xmlns="http://www.w3.org/2000/svg"
                             fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z"/>
                        </svg>
                        <a href="/admin/pages/floors"
                           class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">Etagen</a>
                    </div>
                </li>

                <li v-if="!loading">
                    <div class="flex items-center">
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-300" xmlns="http://www.w3.org/2000/svg"
                             fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z"/>
                        </svg>
                        <a href="#" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                           aria-current="page">
                            {{ floor.name }}
                        </a>
                    </div>
                </li>
            </ol>
        </nav>

        <headline class="mt-4">
            Etage <span class="font-bold">{{ floor.name }}</span>
            <template slot="more">
                <room-create :floor="floor" @reload="load" class="mr-2"></room-create>
                <floor-edit @updated="load" :id="id" class="mr-2"></floor-edit>
                <floor-panel-select :uuid="floor.uuid" class="mr-2"></floor-panel-select>
                <floor-events-panel-select :uuid="floor.uuid" class="mr-2"></floor-events-panel-select>
            </template>
        </headline>

        <loading v-show="loading"></loading>

 
            <card>
                <template v-slot:header>
                    Karte
                </template>

                <p v-show="!floor.map_link">
                    Keine Karte
                </p>

                <p v-show="floor.map_link">
                    <img :src="floor.map_link" alt="Karte">
                </p>

            </card>

    </div>
</template>

<script>

import Headline from "../components/UI/Headline";
import TailwindTable from "../components/UI/TailwindTable";
import FloorEdit from "../components/FloorEdit";
import Popup from "../components/Popup";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import Loading from "../components/UI/Loading";
import Card from "../components/UI/Card";
import CardFullInvisible from "../components/UI/CardFullInvisible";
import RoomCreate from "../components/RoomCreate.vue";
import ButtonWhite from '../components/UI/ButtonWhite.vue';
import FloorPanelSelect from '../panels/FloorPanelSelect.vue'
import FloorEventsPanelSelect from "../panels/FloorEventsPanelSelect.vue";

export default {
    name: "FloorShow",
    components: {
        FloorEventsPanelSelect,
        RoomCreate,
        CardFullInvisible,
        Card,
        Loading,
        ButtonSecondary,
        Popup,
        FloorEdit,
        TailwindTable,
        Headline,
        ButtonWhite,
        FloorPanelSelect
    },

    props: ['id'],

    data: () => ({
        floor: {},
        loading: false,
    }),

    mounted() {
        this.load();
    },

    computed: {
        rooms() {
            if (!this.floor.rooms) {
                return [];
            }
            return this.floor.rooms.sort((a,b) => a.name.localeCompare(b.name));
        },
    },

    methods: {
        load() {
            this.loading = true;
            this.$http
                .get(`/admin/floors/${this.id}`)
                .then((response) => {
                    this.floor = response.data.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    }
}
</script>

<style scoped>

</style>
